import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import InputBox from '../../../../../components/InputBox';
import PillButton from '../../../../../components/PillButton';
import Dropdown from '../../../../../components/Dropdown';
import Button from '../../../../../components/Button';
import Spinner from '../../../../../components/Spinner';

import fetchRecruiterProfile from '../../../../../services/fetchRecruiterProfile';

import './CompanyForm.scss';

const possiblePremiumRanks = [
    {
        id: -1,
        name: 'None'
    },
    {
        id: 11,
        name: 11
    },
    {
        id: 12,
        name: 12
    },
    {
        id: 13,
        name: 13
    },
    {
        id: 14,
        name: 14
    },
    {
        id: 15,
        name: 15
    },
    {
        id: 16,
        name: 16
    },
];

const possiblePremiumRanksiimjobs = [
    {
        id: -1,
        name: 'None'
    },
    {
        id: 11,
        name: 11
    },
    {
        id: 12,
        name: 12
    },
    {
        id: 13,
        name: 13
    },
    {
        id: 14,
        name: 14
    },
    {
        id: 15,
        name: 15
    },
    {
        id: 16,
        name: 16
    },
    {
        id: 17,
        name: 17
    },
    {
        id: 18,
        name: 18
    }
];

const CompanyForm = (props) => {
    const [options, setNewOption] = useState([]);
    const [adminId, setAdminId] = useState('');
    const [isAdminLoading, setIsAdminLoading] = useState(false);
    const [adminDetails, setAdminDetails] = useState({
        name: '',
        email: '',
        platform: process.env.REACT_APP_PLATFORM,
        isLoading: false
    });

    const [showAdminForm, setShowAdminForm] = useState(false);

    const emplDropdown = [
        { text: 'Direct Employer', value: '1' },
        { text: 'Recruitment Firm', value: '2' }
    ];

    const handleSearchAdmin = async () => {
        // return if api call already in progress
        if (isAdminLoading) {
            return;
        }

        setIsAdminLoading(true);

        try {
            const recruiterProfile = await fetchRecruiterProfile(props.adminId, {
                id: adminId
            });

            if (recruiterProfile && recruiterProfile.data) {
                setShowAdminForm(true);
                setAdminId(recruiterProfile.data.id);
                setAdminDetails({
                    email: recruiterProfile.data.email,
                    name: recruiterProfile.data.name,
                    platform: process.env.REACT_APP_PLATFORM
                });

                props.setData({
                    key: 'adminDetails',
                    value: {
                        id: adminId,
                        email: recruiterProfile.data.email,
                        name: recruiterProfile.data.name,
                        platform: process.env.REACT_APP_PLATFORM
                    }
                })
            } else {
                toast.error('Could not find admin profile!');
            }
        } catch (error) {
            toast.error('Could not find admin profile!');
        }

        setIsAdminLoading(false);
    };

    const handleClearAdmin = () => {
        setShowAdminForm(false);
        setAdminId('');

        props.setData({
            key: 'adminDetails',
            value: {}
        });

    }

    useEffect(() => {
        var arr = [];
        (props.data.domains || []).forEach(element => {
            arr.push({ text: element, value: element });

        });
        setNewOption(arr);

        // if admin details are already present, then set in the form
        if (props.data.adminDetails && props.data.adminDetails.id) {
            setAdminDetails({
                email: props.data.adminDetails.email,
                name: props.data.adminDetails.name,
                platform: props.data.adminDetails.platform,
            });
            setAdminId(props.data.adminDetails.id);
            setShowAdminForm(true);
        }
    }, []);

    return (
        <div>
            <div className="inputGroup">
                <label className="managementLabels">Name* :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.name}
                        name="name"
                        onChange={(e) => {
                            props.setData({
                                key: 'name',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">DisplayName* :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.displayName}
                        name="displayName"
                        onChange={(e) => {
                            props.setData({
                                key: 'displayName',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Domains* :</label>

                <div className="managementInputFields">
                    <PillButton onChange={(e, data) => {
                        props.setData({
                            key: 'domains',
                            value: data.value,
                        });
                    }}
                        allowAdditions={true}
                        data={options}
                        defaultValue={props.data.domains}
                        onAddOtherLocation={(e, { value }) => {
                            var newop = options;
                            newop.push({ text: value, value })
                            setNewOption(newop)
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">Industry* :</label>

                <div className="managementInputFields">
                    {' '}
                    <select onChange={(e) => {
                        props.setData({
                            key: 'industry',
                            value: parseInt(e.target.value),
                        });
                    }} >
                        <option name="recType" value="">Select Industry</option>
                        {props.industry.map((ind) => {
                            return props.data.industry == ind.id ? <option name="recType" value={ind.id} selected>
                                {ind.name}
                            </option> : <option name="recType" value={ind.id}>
                                {ind.name}
                            </option>
                        })}
                    </select>

                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">Company Type(Direct Employer/Consultant)* :</label>

                <div className="managementInputFields">
                    {' '}
                    <select onChange={(e) => {
                        props.setData({
                            key: 'type',
                            value: e.target.value,
                        });
                    }} >
                        <option name="recType" value="">
                            Select Employer Type
                        </option>
                        {
                            emplDropdown.map((op) => {
                                return props.data.type == op.value ? <option name="recType" value={op.value} selected>
                                    {op.text}
                                </option> : <option name="recType" value={op.value}>
                                    {op.text}
                                </option>
                            })
                        }
                    </select>
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">InfoEdge Id :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.infoedgeId}
                        name="infoedgeId"
                        onChange={(e) => {
                            props.setData({
                                key: 'infoedgeId',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">First Party Email :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.firstPartyEmail}
                        name="firstPartyEmail"
                        onChange={(e) => {
                            props.setData({
                                key: 'firstPartyEmail',
                                value: e.target.value.trim(),
                            });
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">Comments :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.comment}
                        name="comment"
                        onChange={(e) => {
                            props.setData({
                                key: 'comment',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Hirist Id :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.hiristId}
                        name="hiristId"
                        onChange={(e) => {
                            props.setData({
                                key: 'hiristId',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">iimjobs Id :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.iimjobsId}
                        name="iimjobsId"
                        onChange={(e) => {
                            props.setData({
                                key: 'iimjobsId',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Updazz Id :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        value={props.data.updazzId}
                        name="updazzId"
                        onChange={(e) => {
                            props.setData({
                                key: 'updazzId',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Unicorn Status: </label>
                <div className="managementInputFields">
                    <Checkbox
                        defaultChecked={props.data.unicornStatus == 1 ? true : false}
                        onChange={(event, data) => {
                            props.setData({
                                key: 'unicornStatus',
                                value: data.checked ? 1 : null,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Hirist :</label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanks}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.hirist : null}
                        name="premiumRanksHiristDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.hirist',
                                value: value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Iimjobs: </label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanksiimjobs}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.iimjobs : null}
                        name="premiumRanksIimjobsDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.iimjobs',
                                value: value,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Updazz: </label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanks}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.updazz : null}
                        name="premiumRanksUpdazzDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.updazz',
                                value: value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Platforms to hide from: </label>
                <div className="managementInputFields">
                    <div className="toHideCheckboxContainer">
                        <Checkbox
                            label="iimjobs"
                            defaultChecked={props.data.toHide ? props.data.toHide.iimjobs : false}
                            onChange={(event, data) => {
                                props.setData({
                                    key: 'toHide.iimjobs',
                                    value: data.checked ? true : false,
                                });
                            }}
                        />
                        <Checkbox
                            label="hirist"
                            defaultChecked={props.data.toHide ? props.data.toHide.hirist : false}
                            onChange={(event, data) => {
                                props.setData({
                                    key: 'toHide.hirist',
                                    value: data.checked ? true : false,
                                });
                            }}
                        />
                        <Checkbox
                            label="updazz"
                            defaultChecked={props.data.toHide ? props.data.toHide.updazz : false}
                            onChange={(event, data) => {
                                props.setData({
                                    key: 'toHide.updazz',
                                    value: data.checked ? true : false,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="inputCategory">
                <label className="categoryLabel">Admin Details:</label>

                <div className="inputGroup">
                    <label className="managementLabels">ID:</label>
                    <div className="managementInputFields adminId">
                        <InputBox
                            type="text"
                            value={adminId}
                            onChange={event => {
                                setAdminId(event.target.value);
                            }}
                        />
                        <Button
                            skin='dark'
                            text="Search"
                            disabled={adminId.length == 0 ? true : null}
                            clickButton={handleSearchAdmin}
                        />
                        {isAdminLoading ? (
                            <Spinner />
                        ) : (
                            showAdminForm ? (
                                <Button
                                    text="Clear"
                                    clickButton={handleClearAdmin}
                                    skin="light"
                                />
                            ) : null
                        )}
                    </div>
                </div>

                {showAdminForm ? (
                    <>
                        <div className="inputGroup">
                            <label className="managementLabels">Name:</label>
                            <div className="managementInputFields">
                                <InputBox
                                    type="text"
                                    value={adminDetails.name}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="inputGroup">
                            <label className="managementLabels">Email:</label>
                            <div className="managementInputFields">
                                <InputBox
                                    type="text"
                                    disabled={true}
                                    value={adminDetails.email}
                                />
                            </div>
                        </div>

                        <div className="inputGroup">
                            <label className="managementLabels">Platform:</label>
                            <div className="managementInputFields">
                                <InputBox
                                    type="text"
                                    disabled={true}
                                    value={adminDetails.platform}
                                />
                            </div>
                        </div>
                    </>
                ) : null}
            </div>

        </div>
    );
};

CompanyForm.propTypes = {
    data: PropTypes.object,
    setData: PropTypes.func,
    industry: PropTypes.array,
    adminId: PropTypes.string,
};

export default CompanyForm;
